/**
 * Rounds a date to the next 5-minute tick (5, 10, 15, 20, etc. minute marks).
 * If the time is already on a 5-minute tick, returns the same time.
 * Removes seconds and milliseconds.
 */
export function roundToNext5MinuteTick(date: Date): Date {
  const minutes = date.getMinutes();

  // Calculate the next 5-minute tick
  const next5MinuteTick = Math.ceil(minutes / 5) * 5;

  // Create a new date with the rounded minutes and zero seconds/milliseconds
  const roundedDate = new Date(date);
  roundedDate.setSeconds(0, 0);
  roundedDate.setMinutes(next5MinuteTick);

  return roundedDate;
}
